module.exports = __webpack_public_path__ + "img/hortiImage.fe264b1d.svg";